import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

export function Canonical() {
  const location = useLocation();

  const EXCLUDE_SEGMENTS = ['user', 'admin'];

  const isExcluded = EXCLUDE_SEGMENTS.some(segment =>
    location.pathname.includes(segment)
  );

  if(isExcluded){
    return null
  }
  
  const canonicalUrl = `${window.location.protocol}//${window.location.host}${location.pathname}`;
  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
}
